import { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import Navbar from './Navbar';
import Topbar from './Topbar';
import './Layout.css';
import { SectionRefsContext } from '../../context/SectionRefsContext';

const Layout = () => {

    const backgroundImages = {
        'public-stories': '/images/bg_public_stories.png',
        'favorites': '/images/bg_favorites.png',
        'my-stories': '/images/bg_my_stories.png',
        'create-story': '/images/bg_create_story.png'
    };

    // const [childrenLoaded, setChildrenLoaded]  = useState(false);
    const [activeSection, setActiveSection] = useState('');

    return (
        <SectionRefsContext.Provider value={{activeSection, setActiveSection}}>
            <div className="app-container"
                style={{
                    backgroundImage: backgroundImages[activeSection] ? `url(${backgroundImages[activeSection]})` : undefined,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'fixed',
                    transition: 'background-image 0.6s ease-in-out',
                }}
            >
                <Navbar />
                <Topbar />

                <div className='main-content'>
                    <div className='top-main-content'>
                        <Outlet />
                    </div>

                    <footer className="footer-links">
                        <Link to="/privacy-policy">Privacy Policy</Link>
                        <span>·</span>
                        <Link to="/terms-of-use">Terms of Use</Link>
                        <span>·</span>
                        <Link to="/contact">Contact Us</Link>
                    </footer>
                </div>
            </div>
        </SectionRefsContext.Provider>
    );
};

export default Layout;
